<!--
  AI:
  Status: "in progress"
  Type: Component
  SubType: CrudIntegration
  Reason: Dashboard view for JbJobRun entities with stats cards and QL widget table (read-only)
-->
@if (initialized) {
    <div class="grid mt-2">

        <!-- Header -->
        <div class="col-12">
            <div class="flex justify-content-between py-2 px-4 surface-0 align-items-center shadow-1 border-round">
                <span class="text-lg font-semibold">Job-Läufe</span>
            </div>
        </div>

        <!-- Stats Cards -->
        @if (stats?.length) {
            <div class="col-12">
                <div class="card p-3 shadow-1 border-round surface-0">
                    <div class="flex justify-content-between align-items-center">
                        @for (stat of stats; track stat.label; let first = $first) {
                            <div
                                class="flex flex-column flex-1 justify-content-center surface-border pl-4"
                                [class.border-left-1]="!first">
                                <div class="flex align-items-center">
                                    <i [class]="stat.icon + ' ' + stat.colorClass"></i>
                                    <small class="text-500 font-medium ml-2">{{ stat.label }}</small>
                                </div>
                                <div class="text-2xl font-bold mt-1">
                                    {{ stat.value }}
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        }

        <!-- Main Table Widget -->
        <div class="col-12">
            @if (jobRunTableWidget) {
                <!-- AI: QL Widget table for JbJobRun with row-click navigation (read-only, no create) -->
                <mvs-widget class="shadow-1 border-round block"
                            [widgetData]="jobRunTableWidget"
                            (onObjectSelect)="handleObjectSelect($event)"
                ></mvs-widget>
            }
        </div>

    </div>
}
